var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.excludeRoutes && !_vm.isLanding
    ? _c(
        "header",
        { staticClass: "appbar", attrs: { id: "appbar" } },
        [
          _vm.routerName !== "personas-form" &&
          _vm.routerName !== "empresas-form"
            ? _c(
                "router-link",
                {
                  staticClass: "brand",
                  attrs: { to: { path: "/", query: _vm.$route.query } },
                },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: require("@/assets/logo_conecta.svg"),
                      alt: "Urgencias",
                    },
                  }),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "brand",
                  attrs: {
                    href: _vm.trackedHref("/"),
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: require("@/assets/logo_conecta.svg"),
                      alt: "Urgencias",
                    },
                  }),
                ]
              ),
          _c(
            "v-icon",
            {
              staticClass: "hamburguer_btn",
              attrs: {
                "aria-label": "Menú de navegación",
                color: _vm.PrimaryColor,
                "x-large": "",
              },
            },
            [_vm._v(" mdi-menu ")]
          ),
        ],
        1
      )
    : _vm.isLanding
    ? _c("header", { staticClass: "appbar_landing", attrs: { id: "appbar" } }, [
        _c(
          "a",
          {
            staticClass: "brand",
            attrs: {
              href: _vm.trackedHref("/urgconecta"),
              rel: "noopener noreferrer",
            },
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: {
                src: require("@/assets/logo_conecta.svg"),
                alt: "Urgencias",
              },
            }),
          ]
        ),
        _c(
          "div",
          { staticClass: "landing_right" },
          [
            _c(
              "a",
              {
                staticClass: "landing_phone landing_phone--text",
                attrs: { href: "tel:08002204970" },
              },
              [_vm._v("0800 220 4970")]
            ),
            _c(
              "a",
              {
                staticClass: "landing_phone landing_phone--icon",
                attrs: { href: "tel:08002204970", "aria-label": "Llamar" },
              },
              [_c("v-icon", { attrs: { size: "22" } }, [_vm._v("mdi-phone")])],
              1
            ),
            _c(
              "v-btn",
              {
                staticClass: "landing_cta",
                attrs: { depressed: "", rounded: "" },
                on: { click: _vm.goToCotizar },
              },
              [_vm._v(" COTIZÁ TU PLAN ")]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }